import React, {useState} from 'react';
import {useNavigate} from "react-router-dom";
import {Skeleton} from "@mui/material";
import {toast} from "react-toastify";
import {MDBBtn, MDBCard, MDBCardBody, MDBCardImage, MDBCol, MDBIcon, MDBRipple, MDBRow} from "mdb-react-ui-kit";
import {baseUrl_back} from "../../api/BaseUrl";
import LightBoxFs from "../LightBoxFs/LightBoxFs";
import Typography from "@mui/material/Typography";
import {HeartSVG, HeartSVGRed, PhotoSVG, ShopCart, ShopCartRed} from "../../api/Components/Icons/Icons";
import {Badge, Button, Card} from "antd";
import { Modal } from "antd";
import { TbSquareRoundedLetterOFilled } from "react-icons/tb";
import NewProductCard from "../NewProductCard/NewProductCard";
import OneProductDetail from "../OneProductDetail/OneProductDetail";


const sources=[
    "http://127.0.0.1:8000/Static/Images/Products/Baff_Biryuzovyy_Kationik_kombi/Main.png",
    "https://ra.co/images/events/flyer/2012/4/fr-0417-360153-18233-front.jpg"
]

const NewOneProductMiddle = (props) => {
    let navigate = useNavigate();
    const [toggler, setToggler] = useState(false);
    const [value, setValue] = React.useState(5);
    const [imgLoaded, setimgLoaded] = React.useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [favorXIcon,setxfavorIcon]= React.useState(<MDBIcon far icon="heart" />)
    const [carXticon,setCarticon]= React.useState(<MDBIcon fas icon="cart-plus" />)
    // var defsize=props.elm.SizesAvailability[0]
    // if (props.elm.selected_Size!=null){
    //     defsize=props.elm.selected_Size
    // }

    const [currsize, setCurrSize]= React.useState("all")
    let urlx= props.urlx+"/"+props.elm.article
    let NalichText=""
    let NalichColor=""
    if (props.elm.present>0){
            NalichText=<a style={{color: "black"}}  >Осталось: {props.elm.present}</a>

        if (props.elm.present>5) {
            NalichColor="green"
        } else
        {
            NalichColor="yellow"
        }



    } else {
        NalichText= "Закончился"
        NalichColor="red"
    }
    function handleImageLoaded() {
        // console.log("LOASSS")
        setimgLoaded(true);

    }


    var favorIcon=""
    var carticon=""
    var carticonStyle="light"
    var favoriconStyle="light"
    var sizeColor="light"
    var favor= JSON.parse( localStorage.getItem('favorites'))
    var cart= JSON.parse( localStorage.getItem('cart'))
    const imageStyle = !imgLoaded ? { display: "none" } : {};
    const imageStyleSceleton = imgLoaded ? { display: "none" } : {};

    if (favor == null)
    {       favor=[]
        localStorage.setItem('favorites',JSON.stringify(favor));
    } else {
        favor= JSON.parse( localStorage.getItem('favorites'))
    }

    if (cart == null)
    {       cart=[]
        localStorage.setItem('cart',JSON.stringify(cart));
    } else {
        cart= JSON.parse( localStorage.getItem('cart'))
    }
    if (cart.filter(elm=>elm.name==props.elm._id).length> 0)
    {
        carticon=ShopCartRed
        // carticon=<MDBIcon fas icon="shopping-cart" />;
        // carticon={ShopCart};
        carticonStyle="danger"
    }
    else
    {
        carticon=ShopCart
        carticonStyle="light"
    }

    if (favor.filter(elm=>elm.name==props.elm._id).length> 0)
    {
        favorIcon= HeartSVGRed
        favoriconStyle="danger"
    }
    else
    {
        favoriconStyle="light"
        // favorIcon=<MDBIcon far icon="heart" />;
        favorIcon= HeartSVG
    }

    function SetSize(nme)
    {
        setCurrSize(nme)
    }
    function setInFavor()
    {
        if (favor.filter(elm=>elm.name==props.elm._id).length== 0)
        {
            toast.success('Добавлено в избранное', {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                // pauseOnHover: true,
                draggable: false,
                theme: "dark",
            });

            favor= JSON.parse( localStorage.getItem('favorites'))
            let el={"name": props.elm._id, "size": currsize, "count":1}
            favor.push(el)
            localStorage.setItem('favorites',JSON.stringify(favor));
            props.callbak(favor.length)
            setxfavorIcon(<MDBIcon fas icon="heart" />)

        }else
        {
            toast.error('Удалено из избранного', {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                // pauseOnHover: true,
                draggable: false,
                theme: "dark",
            });
            favor= JSON.parse( localStorage.getItem('favorites'))
            favor = favor.filter((n) => {return n.name != props.elm._id});
            localStorage.setItem('favorites',JSON.stringify(favor));
            props.callbak(favor.length)
            setxfavorIcon('🤍')
        }
    }

    function setInCart()
    {
        if (cart.filter(elm=>elm.name==props.elm._id).length== 0)
        {
            toast.success('Добавлено в корзину', {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                // pauseOnHover: true,
                draggable: false,
                theme: "dark",
            });
            cart= JSON.parse( localStorage.getItem('cart'))
            let el={"name": props.elm._id, "size": currsize, "count":1}
            cart.push(el)
            localStorage.setItem('cart',JSON.stringify(cart));
            props.callbak(cart.length)
            setxfavorIcon('1')
        }else
        {
            toast.error('Удалено из корзины', {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                // pauseOnHover: true,
                draggable: false,
                theme: "dark",
            });
            cart= JSON.parse( localStorage.getItem('cart'))
            cart = cart.filter((n) => {return n.name != props.elm._id});
            localStorage.setItem('cart',JSON.stringify(cart));
            props.callbak(cart.length)
            setxfavorIcon('2')
        }
    }

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };
    function myttt()
    {
        // setIsModalOpen(true);
        // alert(urlx)
        // alert(props.elm.article)
        navigate("/products/"+props.elm.article);
        // setIsModalOpen(true);
    }
    return (
        <>
            {/*<Modal*/}
            {/*    // title="Basic Modal"*/}
            {/*    open={isModalOpen}*/}
            {/*    onOk={handleOk}*/}
            {/*    onCancel={handleCancel}*/}
            {/*    centered={true}*/}
            {/*    closable={true}*/}
            {/*    closeIcon={true}*/}
            {/*    style={{width:"100%", minWidth:"100%", backgroundColor:"red", color:"red"}}*/}
            {/*    footer={null}*/}
            {/*>*/}
            {/*    <OneProductDetail callbak={props.callbak} key={props.elm.id}   elm={props.elm} label={props.elm.name} img={props.elm.id}  urlx={props.elm.id} />*/}
            {/*</Modal>*/}
            {/*<MDBRow className="justify-content-center mb-0 " >*/}
            {/*    <MDBCol>*/}
            <Badge.Ribbon  text={NalichText} color={NalichColor}>
            <MDBCard className="shadow-0  rounded-3 mt-1 mb-0 ">
                <MDBCardBody style={{ backgroundColor: "#382b2f" }}>
                    <MDBRow>
                        <MDBCol

                            className="mb-4 mb-lg-0  hvr">
                            <MDBRipple
                                rippleColor="light"
                                rippleTag="div"
                                className="bg-image rounded hover-zoom hover-overlay "
                            >
                                <Typography variant="caption" display="block" gutterBottom>
                                    арт. {props.elm.article}
                                </Typography>
                                {!imgLoaded ? (<Skeleton animation="wave" variant="rectangular" width={140} height={170} />) : (<></>)}
                                <MDBCardImage
                                    style={imageStyle}
                                    width={250}
                                    src={props.img}
                                    onLoad={handleImageLoaded}
                                    fluid
                                    position='center'
                                    className="h-100"
                                />


                                <a>
                                    <div
                                        target={"_blank"}
                                        href={"/products/"+props.elm.article}
                                        className="mask"
                                        style={{ backgroundColor: "rgba(251, 251, 251, 0.15)" }}
                                    ></div>
                                </a>
                            </MDBRipple>
                            <div  className="mt-0">
                                {/*<Typography onClick={myttt} variant="body1 pointer" gutterBottom>*/}
                                <Typography target={"_blank"} href={"/products/"+props.elm.article} variant="body1 pointer" gutterBottom>
                                    {props.elm.name}
                                </Typography>

                            </div>


                            {/*<a className="text-success">{props.elm.availability_text}</a>*/}
                            {/*<>*/}
                            {/*{(props.elm.present>0)?(*/}
                            {/*    <Badge count={props.elm.present}> YES</Badge>*/}
                            {/*):(*/}
                            {/*    <Badge count={props.elm.present}> NO</Badge>*/}



                            {/*)}*/}
                            {/*</>*/}
                            {/*<Typography className="text-success" variant="caption" display="block" gutterBottom>*/}

                            {/*    {props.elm.present}*/}
                            {/*</Typography>*/}
                            <MDBBtn onClick={setInFavor} outline color={favoriconStyle} size="sm" className="mb-1 mt-1">
                                {favorIcon}
                                {/*{HeartSVG}*/}
                            </MDBBtn>
                            <a> </a>
                            <MDBBtn onClick={setInCart} outline color={carticonStyle} size="sm" className="mb-1 mt-1">
                                {carticon}
                            </MDBBtn>
                            <a> </a>

                            {(props.visfoto==true)?(

                                <MDBBtn   onClick={() => setToggler(!toggler)} outline color="light" size="sm" className="mb-1 mt-1">
                                    {/*<MDBIcon fas icon="camera" />*/}
                                    {PhotoSVG}
                                </MDBBtn>):(<></>)}


                            <div className="d-flex flex-row align-items-center mb-0">
                                <h4 className="mb-1 me-1">{props.elm.Price} ₽ㅤ </h4>
                                {/*<span className="text-danger">*/}
                                {/*            {props.elm.PriceBeforeShow == true?*/}
                                {/*                <s>{props.elm.PriceBefore} ₽</s>*/}
                                {/*                : <a></a> }*/}

                                {/*    </span>*/}
                            </div>

                            <div className="d-flex flex-column mt-1">
                                <MDBBtn target={"_blank"} href={"/products/"+props.elm.article} outline color="light" size="lg" className="mb-2 mt-1">
                                    О товаре
                                </MDBBtn>
                                <>
                                {(props.elm.ozonLink!="")?(

                                        <Button target={"_blank"} href={props.elm.ozonLink} style={{marginBottom: "5px"}} color="primary" variant="solid">
                                            {(NalichText== "Закончился")?("Нет в наличии"):("Купить на Ozon")}

                                        </Button>
                                ): (
                                    <Button style={{marginBottom: "5px"}} color="primary" disabled variant="solid">
                                        нет на Ozon
                                    </Button>
                                )}
                                    {(props.elm.wbLink!="")?(

                                        <Button target={"_blank"} href={props.elm.wbLink} style={{marginBottom: "5px", background: "#a73afd"}}  variant="solid">
                                            Купить на WB
                                        </Button>
                                    ): (
                                        <Button style={{marginBottom: "5px"}} color="primary" disabled variant="solid">
                                            нет на WB
                                        </Button>
                                    )}
                                </>

                            </div>
                        </MDBCol>

                    </MDBRow>
                </MDBCardBody>
            </MDBCard>

            </Badge.Ribbon>
            <LightBoxFs imgs={props.elm.imagesUrls} show={toggler}/>

        </>
    );
};


export default NewOneProductMiddle;